import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'
import { Text } from '@leverege/ui-elements'

import { ScenarioActions, BreadcrumbActions } from '~/actions'

import BlueprintDialogSelector from '~/editors/blueprints/BlueprintDialogSelector'
import { List, Screen, Loading } from '~/views'
import ScenarioItem from './ScenarioItem.jsx'

import style from './scenariosScreen.css'

class ScenariosScreen extends React.Component {

  static propTypes = {
    scenarios : PropTypes.object
  }

  constructor( props ) {
    super( props );
    this.state = { selectId : null, showDialog : false };
  }

  componentDidMount() {
    this.props.dispatch( ScenarioActions.getScenarios( this.props.match.params.projectId ) );
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Scenarios' } ] ) )
  }

  onCreateScenario( ) {
    this.setState( { showDialog : true } )
  }

  onScenarioOpen( scenario ) {
    this.props.history.push( `/project/${scenario.projectId}/scenario/${scenario.id}` )
  }

  onBlueprintSelected = ( item ) => {
    const { dispatch } = this.props
    const { params } = this.props.match
    if ( params.projectId ) {
      dispatch( ScenarioActions.createScenario( { projectId : params.projectId, blueprintId : item.id } ) )
        .then( ( sc ) => { console.log( 'Do I need to push history', sc ) } )
    }
    this.setState( { showDialog : false } )
  }

  onEvent = ( event, scenario ) => {
    const { dispatch } = this.props
    if ( event == 'select' ) {
      this.onScenarioOpen( scenario )
    } else if ( event == ScenarioItem.REMOVE_EVENT ) {
      dispatch( ScenarioActions.removeScenario( scenario.projectId, scenario.id ) );
    } else if ( event == ScenarioItem.DUPLICATE_EVENT ) {
      dispatch( ScenarioActions.duplicateScenario( scenario.projectId, scenario.id ) );
    } else {  
      console.log( 'Event', event, ' on ', scenario );
    }
  }

  render() {
    const scenarios = this.props.scenarios
    if ( scenarios == null ) {
      return <Loading show message="Loading Scenarios..." />
    } 
    const list = (
      <List className={style.list}
        onEvent={this.onEvent}
        noItemsView={<div className={style.noItems}>You have no Scenarios</div>}
        items={scenarios.items}
        itemView={ScenarioItem} />
    );

    return (
      <Screen>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Scenarios</Text>
          <Button bsStyle="primary"
            className="add-button" 
            onClick={() => { this.onCreateScenario() }}> 
            <i className="fa fa-fw fa-circle-plus fa-lg" />
            {' '}
            New Scenario
          </Button>
        </Screen.Header>  
        <Screen.Content>
          {list}
        </Screen.Content>
        <BlueprintDialogSelector
          projectId={this.props.match.params.projectId} 
          show={this.state.showDialog} 
          onClose={() => { this.setState( { showDialog : false } ) }} 
          onItemSelected={this.onBlueprintSelected}
          message="Create a scenario for which blueprint?" />
      </Screen>
    );
  }
} 

export default connect(
  state => ( {
    scenarios : state.scenarios
  } )
)( ScenariosScreen );
